
import React from 'react';

import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { isRuntime } from '../config';


interface Props {
    callback;
}

interface State {
    displayDesign: boolean,
    displayPreview: boolean,
    displayPublish: boolean,
    displaySave: boolean,
    displayDownload: boolean,
    displayStepPreview?: boolean,
    displayUpload?: boolean,
    displayDownloadPayload?: boolean,
    displayDownloadXML?: boolean,
    displayDownloadHelp?: boolean,
}

export class MenuComponent extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            displayDesign: false,
            displayPreview: false,
            displayPublish: false,
            displaySave: false,
            displayDownload: false,
            displayDownloadHelp: false
        };
    }

    render() {
        let allItems = [
            {
                label: 'Design',
                icon: 'pi pi-fw pi-pencil',
                 command: (e) => {
                    this.setState({
                        displayDesign: true,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false,
                        displayStepPreview: false,
                        displayUpload: false,
                        displayDownloadPayload: false,
                        displayDownloadXML: false,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            {
                label: 'Preview',
                icon: 'fa fa-eye',
                command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: true,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false,
                        displayStepPreview: false,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            {
                label: 'Preview by Page',
                icon: 'pi pi-fw pi-step-forward',
                  command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayDownload: false,
                        displayStepPreview: true,
                        displayUpload: false,
                        displayDownloadHelp: false,
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            // {
            //     label: 'Publish',
            //     icon: 'pi pi-fw pi-file-export',
            //     command: (e) => {
            //         this.props.callback({
            //             displayDesign: false,
            //             displayPreview: false,
            //             displayPublish: true,
            //             displaySave: false,
            //             displayDownload: false
            //         })
            //     }
            // },
            {
                label: 'Save',
                icon: 'pi pi-fw pi-save',
                visible: !this.state.displayPreview && !this.state.displayStepPreview || this.state.displayDesign,
                command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: false,
                        displayUpload: false,
                        displaySave: true,
                        displayDownload: false,
                        displayStepPreview: false,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            {
                label: 'Upload',
                icon: 'pi pi-fw pi-upload',
                  command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayUpload: true,
                        displayDownload: false,
                        displayStepPreview: false,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            {
                label: 'Download Layout',
                icon: 'pi pi-fw pi-download',
                 command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayUpload: false,
                        displayDownload: true,
                        displayStepPreview: false,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            {
                label: 'Download Payload JSON',
                icon: 'pi pi-fw pi-download',
                 command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayUpload: false,
                        displayDownload: false,
                        displayStepPreview: false,
                        displayDownloadPayload: true,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
            // {
            //     label: 'Download PDF',
            //     icon: 'pi pi-fw pi-download',
            //     command: (e) => {
            //         this.props.callback({
            //             displayDesign: false,
            //             displayPreview: false,
            //             displayPublish: false,
            //             displaySave: false,
            //             displayDownload: false,
            //             displayDownloadPayload: false,
            //             displayDownloadPDF: true
            //         })
            //     }
            // },
            {
                label: 'Download XML',
                icon: 'pi pi-fw pi-download',
                 command: (e) => {
                    this.setState({
                        displayDesign: false,
                        displayPreview: false,
                        displayPublish: false,
                        displaySave: false,
                        displayUpload: false,
                        displayDownload: true,
                        displayStepPreview: false,
                        displayDownloadPayload: false,
                        displayDownloadXML: true,
                        displayDownloadHelp: false
                    }, () => {
                    this.props.callback({
                       ...this.state,
                    })
                })}
            },
        ];

    const visibleItems = allItems.filter(item => item.visible !== false);
        return (
            <div className="card sticky">
                {/* @ts-ignore */}
                <Menu model={visibleItems}></Menu >
            </div>
        )
    }

}
